module.exports = __webpack_public_path__ + "static/media/id-card@3x.bdc812a0.png";